import { Copy } from 'lucide-react'
import { toast } from 'sonner'
import { Button } from './button'

/** Read-only input + copy button — activation links, API keys, temp passwords (design.md §6). */
export function CopyField({ value, toastMessage = 'Copied to clipboard' }: { value: string; toastMessage?: string }) {
  return (
    <div className="flex items-center gap-2">
      <input
        readOnly
        value={value}
        onFocus={(e) => e.currentTarget.select()}
        className="h-9 w-full rounded-lg border border-border bg-muted px-3 font-mono text-xs text-foreground"
      />
      <Button
        variant="secondary"
        size="sm"
        className="shrink-0"
        onClick={async () => {
          await navigator.clipboard.writeText(value)
          toast.success(toastMessage)
        }}
      >
        <Copy className="size-3.5" /> Copy
      </Button>
    </div>
  )
}
